import LocationAPI from '@api/location.api'

/**
 * 通过百度或者谷歌地图lbs获取城市等信息
 * @param lbs 经纬度
 * @param type 地图类型
 * @returns {any}
 */
export async function getLBSInfo (lbs: { lng: number; lat: number }, type: 'baidu' | 'google' = 'baidu') {
  return new Promise((resolve, reject) => {
    try {
      if (type === 'baidu') {
        const geo: any = new BMap.Geocoder()
        const point = new BMap.Point(lbs.lng, lbs.lat)
        return geo.getLocation(point, (res: any) => {
          console.log('baiduMap逆解析结果：', res, lbs)
          resolve({
            city: res.addressComponents.city || '',
            lbsAddress: res.content?.poi_region?.[0]?.name || ''
          })
        }, {
          poiRadius: 0,
          numPois: 0
        })
      } else if (type === 'google') {
        return LocationAPI.getCityInGoogle(lbs)
          .then((res) => {
            if (res[0]) {
              let address = res[0].name || ''
              console.log('google逆解析结果：', res)
              resolve({
                city: address || '',
                lbsAddress: address || ''
              })
            }
            resolve('')
          }).catch((error) => {
            reject(error)
          })
      }
    } catch (error) {
      reject(error)
    }
  })
}
